
<template>
  <div>
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 手机号码 -->

        <el-col :span="12">
          <el-form-item
            prop="phoneNumber"
            label="手机号码"
          >
            <el-input
              v-model="entityData.phoneNumber"
              disabled
            />
          </el-form-item>
        </el-col>

        <!-- 电子邮箱 -->

        <el-col :span="12">
          <el-form-item
            prop="emailAddress"
            label="电子邮箱"
          >
            <el-input
              v-model="entityData.emailAddress"
              disabled
            />
          </el-form-item>
        </el-col>

        <!-- 姓名 -->

        <el-col :span="12">
          <el-form-item
            prop="userName"
            label="姓名"
          >
            <el-input
              v-model="entityData.userName"
              disabled
            />
          </el-form-item>
        </el-col>

        <!-- 标签 -->
        <el-col :span="12">
          <el-form-item prop="userName2" label="标签">
            <el-tag v-for=" item in getUserTags(entityData.userName2)" :key="item">{{ item }}</el-tag>
          </el-form-item>
        </el-col>

        <!-- 性别 -->
        <el-col :span="12">
          <el-form-item
            prop="sexDictKey"
            label="性别"
          >
            <Combox
              v-model="entityData.sexDictKey"
              type-id="D04"
              :option-data="getComboxData('D04')"
              :add-client="false"
              :disabled="true"
            />
          </el-form-item>
        </el-col>

        <!-- 单位名称 -->
        <el-col :span="12">
          <el-form-item
            prop="danWeiMingCheng"
            label="单位名称"
          >
            <el-input
              v-model="entityData.danWeiMingCheng"
              disabled
            />
          </el-form-item>
        </el-col>

        <!-- 部门 -->

        <el-col :span="12">
          <el-form-item
            prop="buMen"
            label="部门"
          >
            <el-input
              v-model="entityData.buMen"
              disabled
            />
          </el-form-item>
        </el-col>

        <!-- 科室 -->

        <el-col :span="12">
          <el-form-item
            prop="keShi"
            label="科室"
          >
            <el-input
              v-model="entityData.keShi"
              disabled
            />
          </el-form-item>
        </el-col>

        <!-- 职务 -->

        <el-col :span="12">
          <el-form-item
            prop="zhiWu"
            label="职务"
          >
            <el-input
              v-model="entityData.zhiWu"
              disabled
            />
          </el-form-item>
        </el-col>

        <!-- 学位 -->

        <el-col :span="12">
          <el-form-item
            prop="xueWeiDictId"
            label="学位"
          >
            <Combox
              v-model="entityData.xueWeiDictId"
              type-id="D07"
              :option-data="getComboxData('D07')"
              :add-client="false"
              :disabled="true"
            />
          </el-form-item>
        </el-col>

        <!-- 研究领域 -->

        <el-col :span="12">
          <el-form-item
            prop="yanJiuLingYu"
            label="研究领域"
          >
            <el-input
              v-model="entityData.yanJiuLingYu"
              disabled
            />
          </el-form-item>
        </el-col>

        <!-- 研究方向 -->

        <el-col :span="12">
          <el-form-item
            prop="yanJiuFangXiang"
            label="研究方向"
          >
            <el-input
              v-model="entityData.yanJiuFangXiang"
              disabled
            />
          </el-form-item>
        </el-col>

      </el-row>
      <h5>邀请信息</h5>

      <el-row>
        <el-col :span="12">
          <el-form-item
            prop="applyUserName"
            label="邀请人"
          >
            <el-input
              v-model="entityData.applyUserName"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="applyDateTimeShow"
            label="邀请时间"
          >
            <el-input
              v-model="entityData.applyDateTimeShow"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            prop="applyMessage"
            label="留言"
          >
            <el-input
              v-model="entityData.applyMessage"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            prop="friendUserName"
            label="接受者"
          >
            <el-input
              v-model="entityData.friendUserName"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="acceptDateTimeShow"
            label="接受时间"
          >
            <el-input
              v-model="entityData.acceptDateTimeShow"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>
    <!-- 简历展示 -->
    <Resume
      v-model="resumeShow"
      :resume-user-id="resumeUserId"
      :resume-key="resumeKey"
    />
    <div class="dialog-footer">
      <el-button type="primary" style="float:left" @click="handleView">查看简历</el-button>
      <el-button
        type="primary"
        @click="handleBack()"
      >
        &lt;&lt;返回
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
import Resume from '@/components/Resume'
export default {
  components: {
    Combox, Resume
  },
  props: {
    // postId: { type: Number, default: null }
  },
  data() {
    return {
      entityId: null,
      entityData: {},
      allComboxData: [],
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号码', trigger: 'change,blur' }
        ],
        userName: [
          { required: true, message: '请输入姓名', trigger: 'change,blur' }
        ]
      },
      selectedValue: [],
      // 简历数据
      resumeShow: false,
      resumeUserId: null,
      resumeKey: null
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D04;D07').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    getUserTags(strTags) {
      if (strTags) {
        return strTags.split(',')
      } else {
        return []
      }
    },
    /**
     * 初始化数据
     */
    init() {
      this.entityId = this.$route.params.id
      if (!this.entityId) {
        this.$router.go(-1)
        return
      }
      const path = '/api/services/app/Contact/GetVontactViewById?Id=' + this.entityId
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/Contact/CreateOrUpdateContact'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
            })
        }
      })
    },

    /** 返回 */
    handleBack() {
      this.$router.go(-1)
    },
    /** 查看简历 */
    handleView() {
      this.resumeUserId = this.entityData.systemUserId
      this.resumeShow = true
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}

h5 {
  margin: 15px 0;
  padding-left: 6px;
  border-left: 3px solid #b8dbec;
}

</style>
